import React from "react";
import { Link, NavLink, useLocation } from 'react-router-dom';
import appLogo from "../assets/Guide_uni_logo.png";
import 'remixicon/fonts/remixicon.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

const COMPANY_PATHS = ['/how-it-works', '/blog', '/about', '/career', '/contact'];

const Navbar = () => {
  const location = useLocation();
  const isCompanyActive = COMPANY_PATHS.includes(location.pathname);
  return (
    <div className="header">
      <div className="header-top"></div>
      <div className="container-fluid">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container-fluid">
              <Link className="navbar-brand" to="/">
                <img src={appLogo} alt="FlyUrDream Logo" height="40" />
              </Link>

              <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-icon"></span>
              </button>

              <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/universities">Universities</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/recruiters">Recruiters</NavLink>
                  </li>
                  <li className="nav-item">
                    <NavLink className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`} to="/aggregators">Aggregators</NavLink>
                  </li>

                  <li className="nav-item dropdown">
                    <a
                      className={`nav-link dropdown-toggle ${isCompanyActive ? 'active' : ''}`}
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      onClick={(e) => e.preventDefault()}
                    >
                      Company
                    </a>

                    <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                      <li>
                        <NavLink className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`} to="/how-it-works">
                          How It Works
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`} to="/blog">
                          Blog
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`} to="/about">
                          About
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`} to="/career">
                          Careers
                        </NavLink>
                      </li>
                      <li>
                        <NavLink className={({ isActive }) => `dropdown-item ${isActive ? 'active' : ''}`} to="/contact">
                          Contact Us
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                 <li className="nav-item">
  <Link className="nav-link ext-link" to={process.env.REACT_APP_LOGIN_URL}>Login</Link>
</li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navbar;